import BaseService from "./BaseService";
import { unwrapResponse } from "./unwrapResponse";
export default class NotificationService extends BaseService {
    static async getUnreadCount() {
        const res = await this.get(`/notifications/unread-count`);
        return unwrapResponse(res);
    }
    static async getNotifications(params = {}) {
        const res = await this.get(`/notifications`, params);
        return unwrapResponse(res);
    }
    static async readNotifications(id) {
        const res = await this.post(`/notifications/` + id + `/read`);
        return unwrapResponse(res);
    }
    static async postFcmToken(params) {
        const res = await this.post(`/notifications/add-token`, params);
        return unwrapResponse(res);
    }
    static async readAllNotification() {
        const res = await this.post(`/notifications/read-all`);
        return unwrapResponse(res);
    }
}
